import React, { useState } from 'react';
import { FaExternalLinkAlt, FaPlus, FaMinus } from 'react-icons/fa';
import './ExpandableLinkButton.css'; // for styles

export function ExpandableLinkButton({ link }) {
  const [expanded, setExpanded] = useState(false);

  const handleClick = (e) => {
    // prevent expanding if + is clicked
    if (e.target.closest('.expand-toggle')) return;
    window.open(link.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='expandable-link-button' onClick={handleClick}>
      <div className='link-main'>
        <FaExternalLinkAlt className='link-icon' />
        <span className='link-name'>{link.name}</span>
        <button
          type='button'
          className='expand-toggle'
          onClick={() => setExpanded(!expanded)}
          aria-label={expanded ? 'Hide link URL' : 'Show link URL'}
        >
          {expanded ? <FaMinus /> : <FaPlus />}
        </button>
      </div>
      {expanded && <div className='link-url'>{link.url}</div>}
    </div>
  );
}
